import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ActionsMenu from '../ActionsMenu/ActionsMenu.component';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { OverflowTypograpy } from '../OverflowTypography/OverflowTypography.component';
import { ActionMenuItem } from '../ActionsMenu/ActionsMenu.types';
import { IconButton } from '@material-ui/core';

interface ControlledAccordionsProps {
  textSummary: string;
  expandedByDefault: string | false;
  menuItems?: ActionMenuItem[];
  secondaryTextSummary?: string;
  onExpand?: (panel: string) => void;
}

export const ControlledAccordions: React.FC<React.PropsWithChildren<ControlledAccordionsProps>> = ({
  textSummary,
  menuItems,
  secondaryTextSummary,
  expandedByDefault,
  onExpand,
  children,
}) => {
  const [expanded, setExpanded] = React.useState<string | false>(expandedByDefault);

  const expandAccordion = (panel: string) => (event: React.BaseSyntheticEvent) => {
    setExpanded((prev) => (prev ? false : panel));
    if (onExpand) {
      onExpand(panel);
    }
  };
  const panelId = `panel-${textSummary}`;

  return (
    <Accordion
      square
      expanded={expanded === panelId}
      disableGutters
      elevation={0}
      sx={{
        '&:before': {
          display: 'none',
        },
        width: 800,
        borderRadius: 'none !important',
        background: 'none',
        boxShadow: 'none',
        borderBottom: '1px solid rgba(255, 255, 255, 0.5)',
      }}
      TransitionProps={{
        timeout: 0,
        unmountOnExit: true,
      }}
    >
      <AccordionSummary
        sx={{
          flexDirection: 'row-reverse',
          alignItems: 'center',
          '&:focus': {
            outline: '3px solid grey',
          },
        }}
        expandIcon={
          <IconButton onClick={expandAccordion(panelId)} id={panelId} aria-label="panel">
            <ArrowDropDownIcon
              sx={{
                color: 'white',
              }}
            />
          </IconButton>
        }
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <span
          style={{
            width: '710px',
            display: 'inline-block',
            verticalAlign: 'middle',
            marginTop: '5px',
          }}
          onClick={expandAccordion(panelId)}
        >
          <OverflowTypograpy
            sx={{
              textAlign: 'left',
              alignItems: 'center',
              marginLeft: 2,
              color: 'white',
              fontWeight: 600,
              fontSize: 20,
              lineHeight: '20px',
              lineSpace: '1.8px',
              verticalAlign: 'middle',
            }}
          >
            {textSummary}
          </OverflowTypograpy>
        </span>
        {secondaryTextSummary && <Typography sx={{ color: 'text.secondary' }}>{secondaryTextSummary}</Typography>}
        <ActionsMenu
          iconStyle={{
            color: 'white',
            pointerEvents: 'auto',
            visibility: menuItems && menuItems.length ? 'visible' : 'hidden',
          }}
          menuItems={menuItems}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          isNotInTable={true}
        />
      </AccordionSummary>
      <AccordionDetails sx={{ marginTop: -2, marginBottom: -2 }}>{children}</AccordionDetails>
    </Accordion>
  );
};
